import * as React from 'react';
import * as main from "../../main.module.scss";
import * as cost from "./style.module.scss";
import { TaxDeduction } from "../../../../TaxDeduction";
import { Modal } from "../../../../Modal";
export const Cost = ({ widget, sravni }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={cost.cost}>
      <div className="container">
        <div className={cost.wrap} id="purchase">
          <div className={cost.left}>
            <p>Курс-интенсив:</p>
            <h2>Запоминание<br/> 1000 иностранных<br/> слов за неделю</h2>
            <button className={`btn ${main.btn}`} onClick={()=>{setShowModal(true)}}>Подать заявку</button>
          </div>

          <div className={cost.right}>
            <div className={cost.costOld}><del>10&nbsp;000&nbsp;&#8381;</del></div>
            <div className={cost.costNew}>7&nbsp;900&nbsp;&#8381;</div>
          </div>

          <div className={cost.info}>
            <p>Доступ к курсу на&nbsp;1&nbsp;год</p>
            <TaxDeduction linkInner={sravni}/>
          </div>

        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
